import * as React from "react";
import styled from "styled-components";
const Badge = styled.span`
  position: relative;

  &::after {
    display: 'block';
    content: ' ';
    position: absolute;
    width: 8px;
    height: 8px;

    background-color: ${({ theme }) => theme.colors.brand.primary};
    border-radius: 50%;
    top: 0;
    right: -12px;
  }
`;
const MenuItemDotBadge = ({ text, title, showDot }) => {
  if (!showDot) {
    return /* @__PURE__ */ React.createElement("span", null, text);
  }
  return /* @__PURE__ */ React.createElement(Badge, { title }, text);
};
export default MenuItemDotBadge;
